;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import type { MouseEvent } from "react"
import map from "lodash/map"
import guessAndCastDateTimeToLocal from "../../../../../lib/formatter/guessAndCastDateTimeToLocal"
import TablePagination from "../../../../common/TablePagination"
import { SessionDate } from "../../types"

const PAGE_SIZE = 5

type Props = {
  page: number
  setPage: (value: number) => void
  isDefinite: boolean
  nextSessions: SessionDate[]
  nextSessionsTotalCount: number
}

export default function SessionDatesTable({
  page,
  setPage,
  isDefinite,
  nextSessions,
  nextSessionsTotalCount,
}: Props) {
  const handleNextButtonClick = async () => {
    if (page === Math.floor(nextSessionsTotalCount / PAGE_SIZE)) {
      return
    }
    setPage(page + 1)
  }

  const handleBackButtonClick = async () => {
    if (page === 0) {
      return
    }
    setPage(page - 1)
  }

  const onPageChange = async (
    _event: MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    if (newPage > page) {
      await handleNextButtonClick()
    } else {
      await handleBackButtonClick()
    }
    setPage(newPage)
  }

  const renderPagination = () => {
    return isDefinite ? (
      <TablePagination
        totalCount={nextSessionsTotalCount}
        pageSize={PAGE_SIZE}
        page={page}
        onPageChange={onPageChange}
      />
    ) : null
  }

  const renderSessionRows = () => {
    const startIndex = page * PAGE_SIZE
    const endIndex = startIndex + PAGE_SIZE
    const currentSessions = nextSessions.slice(startIndex, endIndex)

    return map(currentSessions, ({ startsAt, endsAt }, index) => {
      const startsAtCastToLocalTime = guessAndCastDateTimeToLocal(startsAt)
      const endsAtCastToLocalTime = guessAndCastDateTimeToLocal(endsAt)
      const timeSpan = startsAtCastToLocalTime.isSame(endsAtCastToLocalTime, "day")
        ? `${startsAtCastToLocalTime.format("h:mm A")} - ${endsAtCastToLocalTime.format(
            "h:mm A",
          )}, ${startsAtCastToLocalTime.format("ddd, MMM D, YYYY")}`
        : `${startsAtCastToLocalTime.format("h:mm A ddd MMM D, YYYY")} - ${endsAtCastToLocalTime.format("h:mm A ddd MMM D, YYYY")}`

      return (
        <div
          className="flex flex-row items-center my-[10px]"
          key={`session-row-${index}`}
        >
          <div
            id={`circle-${index}`}
            className={
              "flex justify-center items-center h-[33px] w-[33px] bg-white border-solid border-black border-[1px] rounded-full mr-[20px] shrink-0"
            }
          >
            {index + page * PAGE_SIZE + 1}
          </div>
          <div>{timeSpan}</div>
        </div>
      )
    })
  }

  return (
    <div className="mt-[20px]">
      {renderSessionRows()}
      {renderPagination()}
    </div>
  )
}
